(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
  .controller('ModalDetalheAnaliticoDirectiveController', ModalDetalheAnaliticoDirectiveController);

  ModalDetalheAnaliticoDirectiveController.$inject  = ['$uibModal', 'VisualizacaoService'];
  
  function ModalDetalheAnaliticoDirectiveController($uibModal, VisualizacaoService) {
    var vm = this;
    vm.openModal = openModal;

    function openModal() {
      VisualizacaoService.getDetalhamentoAnalitico(vm.pess, vm.rel, vm.id)
      .then(function (data) {
        $uibModal.open({
          templateUrl: 'module/validacao/visualizacao/modalDetalheAnalitico/modal-detalhe-analitico.html',
          controller: 'ModalInstanceDetalheAnalitico',
          controllerAs: 'vm',
          windowClass: 'modal-detalhamento',
          resolve: {
            detalhamentoAnalitico: function () {
              return data;
            }
          }
        });
      });
    }
  }
})();
